
const registrations = [
    {
        "uuid":"1",
        "activityId":"S10",
        "customer":"源天然股份有限公司",
        "assessmentPlace":"台東廠, 屏東廠",
        "estimatedProductNumber":15,
        "standardTseYue":true,
        "standardLeezen":true,
        "createdOn":"2021-03-12T08:20:10.000Z",
        "individual":false,
        "companyName":"源天然股份有限公司",
        "personInCharge":"王小花",
        "taxIdNo":"24485314",
        "companyAddress":"11501 台北市南港區三重路19-11號",
        "contactPerson":"聯絡我",
        "jobTitle":"採購專員",
        "contactPhone":"02-7723-8001",
        "contactMobile":"0912098123",
        "fax":"02-7723-8002",
        "email":"flower@gmai.com",
        "mailingAddress":"11501 台北市南港區三重路19-11號",
        "relatedCorporateCustomers":["leezen"],
        "productCategory":"冷凍食品類,冷藏調整食品類",
        "vegetarianFood":"Y",
        "appliedStandards":["tseyue","leezen"],
        "assessmentPlaces":[
            {
                "uuid":"1",
                "name":"台東廠",
                "assessmentCategory":"加工食品",
                "registrationNo":"110057077",
                "relationshipWithApplicant":"company",
                "personInCharge":"王小花",
                "address":"11501 台北市南港區三重路19-11號",
                "productionLineDescription":"飲料線、乳品線",
                "productionLines":[
                    {"productionLine":"飲料線", "productionProcess":"原料驗收-->原料前處理-->調理-->包裝-->成品"},
                    {"productionLine":"乳品線", "productionProcess":"加工中心機、鑽床、鏜床、鉋床、 鋸床、拉床及雕刻機"}
                ],
                "entrustExternalUnit":"N"
            },
            {
                "uuid":"2",
                "name":"屏東廠",
                "assessmentCategory":"加工食品",
                "registrationNo":"110057077",
                "relationshipWithApplicant":"others",
                "relationshipWithApplicantDesc":"test111",
                "personInCharge":"張大同",
                "address":"11401 台北市大安區忠孝東路四段303號10樓234室",
                "productionLineDescription":"巧克力及糖果、保健食品、健康系列",
                "productionLines":[
                    {"productionLine":"巧克力及糖果", "productionProcess":"原料驗收-->原料前處理-->調理-->包裝-->成品"},
                    {"productionLine":"保健食品", "productionProcess":"原料驗收-->原料前處理-->調理-->包裝-->成品"},
                    {"productionLine":"健康系列", "productionProcess":"原料驗收-->原料前處理-->調理-->包裝-->成品"}
                ],
                "entrustExternalUnit":"Y",
                "unit":"高雄委外場所",
                "contactPerson":"Steven Wang",
                "cooperativeContent":"諸如金屬礦石之類的原材料或諸如食品之類的農產品或諸如棉花和亞麻之類的紡織來源植物需要一系列處理以使其有用。",
                "causeProductRisk":'Y',
                "riskDescription":"對於金屬，這些過程包括粉碎，熔煉和進一步精煉"
            }
        ]
    },
    {
        "uuid":"2",
        "activityId":"S10",
        "customer":"豆之家食品科技股份有限公司",
        "assessmentPlace":"桃園廠",
        "estimatedProductNumber":15,
        "standardTseYue":true,
        "standardLeezen":false,
        "createdOn":"2021-03-21T08:20:10.000Z",
        "individual":true,
        "companyName":"豆之家食品科技股份有限公司",
        "personInCharge":"王小花",
        "taxIdNo":"24485314",
        "companyAddress":"11501 台北市南港區三重路19-11號",
        "contactPerson":"麟洛我",
        "contactPhone":"02-7723-8001",
        "contactMobile":"0912098123",
        "fax":"02-7723-8002",
        "email":"flower@gmai.com",
        "mailingAddress":"11501 台北市南港區三重路19-11號",
        "relatedCorporateCustomers":["leezen","tseyue"],
        "productCategory":"冷凍食品類,冷藏調整食品類,冷藏生鮮蔬果類食物",
        "vegetarianFood":"N",
        "appliedStandards":["leezen"],
        "assessmentPlaces":[
            {
                "uuid":"1",
                "name":"桃園廠",
                "assessmentCategory":"加工食品",
                "registrationNo":"110057077",
                "relationshipWithApplicant":"company",
                "personInCharge":"王小花",
                "address":"11501 台北市南港區三重路19-11號",
                "productionLineDescription":"飲料線及乳品線",
                "briefProductionProcess":"飲料線生產流程:原料驗收-->原料前處理-->調理-->包裝-->成品。\n" +
                    "乳品線生產流程：加工中心機、鑽床、鏜床、鉋床、 鋸床、拉床及雕刻機",
                "entrustExternalUnit":false
            }
        ]
    }
]

export default registrations;